import { type ReactElement, type ReactNode, useMemo } from 'react';
import { FeatureFlagsContext } from './featureFlagsContext';
import type { FeatureFlagResolveResult } from '@/shared/data/featureFlags';

export const FeatureFlagsProvider = ({
  flags,
  loading,
  children,
}: {
  flags: FeatureFlagResolveResult['flags'] | null;
  loading: boolean;
  children: ReactNode;
}): ReactElement => {
  const value = useMemo(() => ({ flags, loading }), [flags, loading]);
  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};
